import { createContext } from 'react';

const ImportBookingDotComPropertiesContext = createContext(undefined);

export default ImportBookingDotComPropertiesContext;
